var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPowershell = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#E0EAF5",
  fillRule: "evenodd",
  d: "M13.943 3.568c2.512 0 5.024-.008 7.537.002 1.493.007 1.914.506 1.592 1.98a1675.68 1675.68 0 0 1-2.884 12.948c-.309 1.363-1.019 1.92-2.452 1.925-5.025.015-10.05.017-15.074 0-1.642-.006-2.074-.563-1.72-2.119.96-4.227 1.925-8.453 2.898-12.677.37-1.61.927-2.051 2.566-2.056 2.512-.007 5.024-.002 7.537-.003Z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#2671BE",
  fillRule: "evenodd",
  d: "M10.146 19.921c-2.512 0-5.025.01-7.538-.006-1.274-.008-1.505-.309-1.218-1.555.972-4.226 1.975-8.445 2.926-12.676.255-1.135.805-1.636 2.02-1.625 5.025.046 10.051.015 15.076.02 1.26.001 1.472.27 1.189 1.549a2384.81 2384.81 0 0 1-2.783 12.442c-.352 1.551-.758 1.847-2.39 1.85-2.427.006-4.855.002-7.282.001Z",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#FDFDFE",
  fillRule: "evenodd",
  d: "M12.284 11.638c-.168-.197-.353-.425-.55-.642-1.11-1.234-2.21-2.477-3.34-3.692-.518-.556-.683-1.096-.062-1.645.614-.543 1.217-.495 1.78.13 1.569 1.738 3.135 3.477 4.73 5.191.595.64.456 1.076-.2 1.55a1004.966 1004.966 0 0 0-7.518 5.508c-.561.414-1.097.518-1.551-.095-.5-.675-.037-1.077.482-1.455a812.489 812.489 0 0 0 5.557-4.08c.257-.19.626-.302.672-.77Z",
  clipRule: "evenodd"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#FCFDFD",
  fillRule: "evenodd",
  d: "M13.08 18.175c-.677 0-1.354.023-2.029-.008-.538-.024-.862-.325-.856-.892.007-.537.277-.94.815-.954a95.86 95.86 0 0 1 4.438-.002c.47.009.817.315.814.805-.003.562-.299.997-.9 1.033-.758.046-1.521.012-2.282.012v.006Z",
  clipRule: "evenodd"
})));
export default SvgPowershell;